<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm10 md8 lg6>
      <v-card class="elevation-12" align-center justify-center>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Mutton Bustin' Championship Registration</v-toolbar-title>
        </v-toolbar>
        <v-img
          src="/static/img/logo.png"
          height="150"
          contain
        ></v-img>

        <div class="headline text-xs-center mb-4">{{ currentYear }} RENO RODEO MUTTON BUSTIN' CHAMPIONSHIP APPLICATION</div>
        <div v-if="saved">
          <div class="subheading mx-4">
            <p>Your Application has been entered.. The drawing will be held on <b>March 7th at 10 AM</b>. A 100 applications will be chosen by the computer randomly. The rest will be put on a waiting list.
              An entry fee of $75.00 will be charged to the 100 kids that are drawn by the computer.</p>

            <p>Check in will start at 9:45 a.m. on Sunday, June 21st, {{ currentYear }} in the indoor arena. At check in, you will receive a back number for the participant. The event will consist of five (5)
              go rounds, with twenty (20) participants each.. At the end of the five (5) go rounds, the ten (10) best times will be competing in the 8th Annual Reno Rodeo Mutton Bustin' Championship!
              Top three (3) will receive trophies and the winner will also receive a belt buckle.</p>

            <p class="headline text-xs-center mt-4"><span class="red--text">ONLY ONE APPLICATION PER CHILD!</span></p>
          </div>
        </div>
        <div v-else>
          <div class="subheading mx-4">
            <p>Reno Rodeo Kids' Day Muttun Bustin' Championship will be on <b>Sunday, June 21st, {{ currentYear }}</b>. The application will appear on the website <b>March 2nd at 8 AM through March 6th</b>.
              It will come down at <b>midnight</b>. The drawing will be held on <b>March 7th at 10 AM</b>. A 100 applications will be chosen by the computer randomly. The rest will be put on a waiting list.
              An entry fee of $75.00 will be charged to the 100 kids that are drawn by the computer.</p>

            <p>Participants must be at least 5 years of age and no more then 7 years of age by the first day of the 2026 Reno Rodeo (<b>June 18, {{ currentYear }}</b>). A copy of the participant's birth
              certificate will be required at sign in. Participants may not weigh more than 65 pounds. (For the safety of our animals and the safety of your children, we emphasize the weight limit of no
              more than 65 pounds). Western attire is required (i.e. long sleeve shirt, long pants, and boots). Helmets and vests will be supplied by a sponsor, as they are required during the ride. The
              participants and one (1) adult only will be allowed in the chute area.</p>

            <p><span class="red--text">We do not accept walk-ups, faxes or mailed in applications!</span></p>
          </div>

          <div class="headline text-xs-center mt-4">
            All information is required. Please print.<br />
            If phone number is not included, we cannot call you<br />
            and the child will not be entered.<br />
            <span class="red--text">ONLY ONE APPLICATION PER CHILD!</span>
          </div>

          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
          >
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.name"
                    label="Rider Name"
                    ref="focusName"
                    :rules="[v => !!v || 'Name is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.address"
                    label="Address"
                    :rules="[v => !!v || 'Address is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs10 md5>
                      <v-text-field
                        v-model="editedItem.city"
                        label="City"
                        :rules="[v => !!v || 'City is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 md2>
                      <v-text-field
                        v-model="editedItem.state"
                        label="ST"
                        mask="AA"
                        :rules="[v => !!v || 'State is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md5>
                      <v-text-field
                        v-model="editedItem.zip"
                        label="Zipcode"
                        mask="#####"
                        :rules="[v => !!v || 'Zip is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="editedItem.cellPhone"
                    label="Primary"
                    mask="(###) ###-####"
                    return-masked-value
                    prepend-icon="stay_current_portrait"
                    :rules="[v => !!v || 'Primary Phone is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="editedItem.homePhone"
                    label="Alternate"
                    mask="(###) ###-####"
                    return-masked-value
                    prepend-icon="phone"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    prepend-icon="email"
                    label="Email"
                    type="email"
                    v-model="editedItem.email"
                    :rules="emailRules"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="editedItem.age"
                    label="Age"
                    mask="#"
                    :rules="[v => !!v || 'Age is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="editedItem.weight"
                    label="Weight"
                    mask="##"
                    :rules="[v => !!v || 'Weight is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 md4>
                  <v-text-field
                    v-model="editedItem.birthDate"
                    label="Birthdate"
                    mask="##/##/####"
                    return-masked-value
                    prepend-icon="cake"
                    :rules="[v => !!v || 'Birthdate is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.parents"
                    label="Parent or Legal Guardian"
                    :rules="[v => !!v || 'Parent or Legal Guardian is required']"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>

            <v-alert :value="error" type="warning" transition="scale-transition">
              <span v-html="error"></span>
            </v-alert>

            <div class="headline text-xs-center mb-4">
              {{ currentYear }} RENO RODEO MUTTON BUSTIN' CHAMPIONSHIP<br />
              COMPLETE PARTICIPANTS RELEASE
            </div>

            <div class="subheading mx-4">
              <p>The undersigned, being over the age of majority, understands and acknowledges that rodeo events are dangerous activities and that
                participation in any rodeo event, as either a contestant, employee, volunteer, or other participant, exposes the participant to a
                substantial and serious risk of personal injury, death or property damage, especially for children. The undersigned also understands
                and acknowledges that the animals used in rodeo events of Reno Rodeo Association have unpredictable behavior and also that the animals’
                behavior may be unknown, as is the participant’s ability to control the animal. The undersigned expressly acknowledges that participation
                or his child’s participation in any rodeo event will involve such hazards.</p>

              <p>Mindful of these facts, the undersigned, intending to be legally bound hereby, and in consideration of being allowed to participate,
                or being allowed to have a child participate, in the 7th Annual Reno Rodeo Mutton Bustin’ Championship, does hereby forever release,
                on behalf of himself and/or his child(ren), Reno Rodeo Association, the County of Washoe, and employees, agents, affiliates and
                sponsors, from any liability under any and all causes, known or unknown, by reason of any injury, loss, damage, death or otherwise,
                which may be suffered by the undersigned or his child(ren) and hereby assumes and accepts, on behalf of himself and/or his child(ren),
                the risk and dangers of injury, pain, suffering, damage, death or other loss which may occur through or by reason of any matter, thing,
                condition, negligence, or default.</p>

              <p>The undersigned agrees to indemnify, hold harmless and defend the Reno Rodeo Association, the County of Washoe, and the State of Nevada,
                and any suppliers, sponsors, and each and every and all of their officers, directors, members, servants, employees, agents or affiliates,
                of and from any and all loss, liability or damage arising out of, directly or indirectly, the participation of the undersigned or his
                child(ren) in the 7th Annual Reno Rodeo Mutton Bustin’ Championship.</p>

              <p>This release shall be binding upon the undersigned and the undersigned’s spouse, legal representatives, child(ren), heirs, successors
                and assigns, and should any term or other provision of this release be held invalid, illegal or incapable of being enforced due to any
                rule of law or public policy, all of the other conditions, provisions and paragraphs of this release shall nevertheless remain in full
                force and effect. I agree to be bound in my individual capacity as a parent or legal guardian for the child(ren) I enter into or allow
                to participate in the 2nd Annual Reno Rodeo Mutton Bustin’ Championship.</p>

              <p>The laws of the State of Nevada will apply in all instances regarding the interpretation and enforceability of this release and this
                release shall be performed in the County of Washoe, State of Nevada.</p>

              <p>The undersigned has full power, authority, capacity and right without limitations to execute, deliver and perform this completed release.</p>

              <p>This release has been carefully and fully read by the undersigned and the undersigned fully understands its terms and conditions and
                has voluntarily executed and delivered this release by choosing the checkbox below.</p>
            </div>

            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-checkbox
                v-model="checkbox"
                label="I have read and agree to the Complete Participants Release!"
                :rules="[v => !!v || 'You must agree to continue!']"
                required
              ></v-checkbox>
              <v-btn color="primary" @click="save">Submit Application</v-btn>
            </v-card-actions>
          </v-form>
        </div>
      </v-card>
    </v-flex>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import moment from 'moment'

export default {
  data () {
    return {
      valid: true,
      currentYear: 0,
      checkbox: false,
      saved: false,
      editedItem: {
        name: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        homePhone: '',
        cellPhone: '',
        email: '',
        age: '',
        weight: '',
        birthDate: '',
        other: '',
        parents: ''
      },
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      error: null,
      snackbar: {
        show: false,
        color: '',
        message: ''
      }
    }
  },

  created () {
    this.getDate()
  },

  methods: {
    getDate () {
      let currentYear = moment().format('YYYY')
      let nextYear = moment()
        .add(1, 'years')
        .format('YYYY')
      let currentDate = moment().format('MM')

      if (currentDate >= 7) {
        this.currentYear = nextYear
      } else {
        this.currentYear = currentYear
      }
    },

    async save () {
      try {
        this.editedItem.year = this.currentYear
        this.editedItem.status = 'Pending'

        if (this.$refs.form.validate()) {
          const response = await Api().post('extern_mbchamps', this.editedItem)
          console.log(response.data)

          this.saved = true
          this.snackbar.message = 'Congratulation, your child has been submitted!'
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } else {
          this.snackbar.message = 'You have some errors on the page!'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/mbChampionship/ExternalForm.vue